import { useState, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import buildRoute from "components/buildRoute";
import { canCreateRecordType } from "../hartUtils";
import { trackEvent } from "../../../configureMixpanel";

// Configuration for available tables - easily extendable
const AVAILABLE_TABLES = [
  {
    value: 'jobs',
    label: 'Job'
  },
  {
    value: 'sessions',
    label: 'Session'
  },
  {
    value: 'vendors',
    label: 'Vendor'
  },
  {
    value: 'clients',
    label: 'Client'
  },
  {
    value: 'facilities',
    label: 'Facility'
  },
  // {
  //   value: 'finances',
  //   label: 'Finance'
  // },
  // Add more tables here
];

export const AddNewPage = () => {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const [selectedTable, setSelectedTable] = useState('');

  const allowedTables = useMemo(
    () => AVAILABLE_TABLES.filter((t) => canCreateRecordType(t.value, projectId)),
    [projectId]
  );

  const handleNext = () => {
    if (selectedTable) {
      trackEvent("hart_add_new_type_selected", { record_type: selectedTable });
      navigate(`/projects/${projectId}/hart/new/${selectedTable}`);
    }
  };

  return (
    <>


      <Card sx={{ mb: 3, mt: 2.5 }}>
        <CardContent>
          <Typography variant="h2" sx={{ mb: 3 }}>
            Choose Data to Enter
          </Typography>
          <FormControl fullWidth>
            <InputLabel id="table-select-label" shrink>Select an action</InputLabel>
            <Select
              labelId="table-select-label"
              id="table-select"
              value={selectedTable}
              label="Select an action"
              onChange={(e) => setSelectedTable(e.target.value)}
              displayEmpty
              notched
            >
              {allowedTables.map((table) => (
                <MenuItem key={table.value} value={table.value}>
                  {table.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Box sx={{ mt: 4, display: 'flex', justifyContent: 'space-between' }}>
            <Button
              variant="outlined"
              onClick={() => navigate(`/projects/${projectId}/hart`)}
            >
              Back to Home
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={handleNext}
              disabled={!selectedTable}
            >
              Next
            </Button>
          </Box>
        </CardContent>
      </Card>
    </>
  );
};

const routeArgs = {
  element: <AddNewPage />,
};

export default buildRoute(routeArgs);

